import { OwcTypography, OwcTooltip } from "@one/react";
import moment from "moment";
import PropTypes from "prop-types";
import { getRepetitionIcon } from "../../../../utils/helpers/getRepetitionIcon";
import getRRuleDisplayText from "../../../../utils/helpers/text/transformRRuleToText";

const DateTimeRange = ({ start, end, timezone, repetitionPattern }) => {
  const timeFrom = moment(start).tz(timezone).format("hh:mm A");
  const timeTo = moment(end).tz(timezone).format("hh:mm A");
  const dateFromFormatter = moment(start).tz(timezone).format("DD-MMM-YYYY");
  const dateToFormatter = moment(end).tz(timezone).format("DD-MMM-YYYY");
  const recurranceText = getRRuleDisplayText(repetitionPattern, new Date(start), timezone);

  const displayText = `${dateFromFormatter}, ${timeFrom} - ${dateToFormatter}, ${timeTo}`;

  return (
    <>
      <OwcTypography variant="caption">Date and time range</OwcTypography>

      <OwcTypography variant="button" id={"date_time_range_display"}>
        {displayText}
      </OwcTypography>
      <OwcTooltip anchor={"date_time_range_display"} offset={[0, 0]}>
        {displayText}
      </OwcTooltip>
      {recurranceText && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px'}}>
          {getRepetitionIcon(recurranceText)} {recurranceText}
        </div>
      )}
    </>
  );
};

DateTimeRange.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired
};

export default DateTimeRange;
